import Request from "./Request";

class FairApi {

  static generateScores(){
  	return new Request("/scoring/generate-scores")
  }
  
}

export default FairApi;



// WEBPACK FOOTER //
// ./src/components/utils/FairApi.js